import { useTranslation } from 'react-i18next';
import { usePageNotice } from '../../context/FeedbackContext';

function ExchangeRateMissingAlert({ errorInfo, noticeId = 'exchange-rate-missing' }) {
  const { t } = useTranslation();
  const shouldShow = errorInfo?.code === 'MISSING_EXCHANGE_RATE';

  const pair = errorInfo?.fromCurrency && errorInfo?.toCurrency
    ? `${errorInfo.fromCurrency} → ${errorInfo.toCurrency}`
    : null;

  usePageNotice(
    noticeId,
    shouldShow
      ? {
        severity: 'warning',
        persist: true,
        title: t('checks.exchangeRateMissingTitle'),
        message: pair
          ? t('checks.exchangeRateMissingPair', { pair })
          : t('checks.exchangeRateMissingBody'),
      }
      : null,
  );

  return null;
}

export default ExchangeRateMissingAlert;
